import React, { Component } from 'react';
import Slider from 'react-slick';
import InfoblockLink from '../InfoBlocks/InfoblockLink';
import AdvertisingLabeling from '../AdvertisingLabeling/AdvertisingLabeling';
import Icon from "../common/Icon";
import LinkC from '../common/LinkC';
import InfoBlockShop from '../InfoBlocks/InfoBlockShop';

function SampleNextArrow(props) {
    const { onClick } = props;
    return <div className="rates-carousel-arrow rates-carousel-arrow--next" onClick={onClick} />;
}

function SamplePrevArrow(props) {
    const { onClick } = props;
    return <div className="rates-carousel-arrow rates-carousel-arrow--prev" onClick={onClick} />;
}

class ShopCarousel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isSm: false,
            settings: null
        };
    }

    componentDidMount() {
        if (typeof window !== "undefined") {
            window.addEventListener('resize', this.onResize);
            if (window.innerWidth <= 767 && !this.state.isSm) this.setState({ isSm: true });
        }

        if (!this.state.settings) {
            this.setState({ settings: this.setSetting() });
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.onResize);
    }

    onResize = () => {
        let { isSm } = this.state;
        if (typeof window !== 'undefined') {
            if (window.innerWidth <= 767 && !isSm) this.setState({ isSm: true });
            if (window.innerWidth >= 768 && isSm) this.setState({ isSm: false });
            this.setSetting();
        }
    };

    setSetting = () => {
        let sliderToShowDef = 4;
        let slidesToShow1023Def = 3;
        
        return {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: sliderToShowDef,
            slidesToScroll: 1,
            swipeToSlide: true,
            nextArrow: <SampleNextArrow />,
            prevArrow: <SamplePrevArrow />,
            draggable: false,
            responsive: [
                {
                    breakpoint: 1440,
                    settings: {
                        slidesToShow: slidesToShow1023Def,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: slidesToShow1023Def,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: slidesToShow1023Def,
                        slidesToScroll: 1
                    }
                }
            ]
        };
    };

    renderContent = () => {
        return this.props.blocks.map((block) => {
            const imageSrc = block.imagePath.trim().length > 0 ? block.imagePath : require("../../../images/content/no_photo.png");

            return (
                <div className="b-product-slider__slide" key={block.alias}>
                    <div className="b-product-slider__slide--flat shop">
                        <AdvertisingLabeling token={block.token} advertiser={block.advertiser} />
                        <div className="js-product-init b-product-plate b-product-plate_adapt_default b-product-plate_hover_b2c">
                            <div className="b-product-plate__wrapper shop">
                                <div className="b-product-plate__img-holder">
                                    <img className="b-product-plate__image b-product-plate__image_def" src={imageSrc} alt="" role="presentation" />
                                </div>
                                <div className="b-product-plate__content">
                                    <div className="b-product-plate__main-area">
                                        <div className="b-product-plate__name">{block.title}</div>
                                    </div>
                                    <div className="b-product-plate__price-area">
                                        {block.text.includes('₽') ? (
                                            <div className="b-product-plate__price">
                                                {block.text.replace('₽', '')}
                                                <span className="b-product-plate__price price-rub">₽</span>
                                            </div>
                                        ) : (
                                            <div className="b-product-plate__price">{block.text}</div>
                                        )}
                                        <InfoblockLink className="b-product-plate__action-block" item={block}>
                                            <Icon name="icon_basket-pl" className="b-product-plate__action-icon u-icon u-icon_basket-pl" />
                                            <span className="b-product-plate__action-text">{block.link_title}</span>
                                        </InfoblockLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        });
    };

    render() {
        const { isSm, settings } = this.state;
        const { blocks } = this.props
        const shopBlocks = blocks.slice(0, 4);


        return !isSm && !!settings ?
            <div div className="page__product-plates" >
                <div className='js-prod-slider b-product-slider_adapt_b2c b-product-slider_hover_b2c'>
                    <div className="b-product-slider__wrapper">
                        <div className="b-product-slider__header">
                            <div className="b-product-slider__title">
                                <div className="b-product-slider__title-label">Интернет–магазин</div>
                            </div>
                        </div>

                        <Slider {...settings} >
                            {this.renderContent()}
                        </Slider>

                    </div>
                    <div className="b-product-slider__link-sector">
                        <LinkC noFollow={true} className="b-product-slider__link" to="https://shop.motivtelecom.ru/">Перейти в интернет – магазин</LinkC>
                    </div>
                </div>
            </div >
            :
            <div className={''}><InfoBlockShop blocks={shopBlocks} /></div>
            ;
    }
}

export default ShopCarousel;
